import { useParams } from 'react-router-dom';
import { useCSMGet } from '../../api/csm';
import { getUserFullName } from 'utils';

export default function useCsmInfo() {
  const { csmId } = useParams();

  const { data: csmDetails = {} } = useCSMGet(csmId);
  const { first_name = '', last_name = '' } = csmDetails;

  return { ...(csmDetails ?? {}), name: getUserFullName(first_name, last_name) };
}
